<template>
    <main class="help-page-layout position-relative clinician-level-two">
        <section
            :class="`page-content mt-2 mx-1 mx-md-3 px-0 ${!hasAgencyCore && !hasHomeCare ? 'no-message-access' : ''} App__Personal`"
        >
            <PersonalHelp />
            <div class="row-span-2">
                <PersonalMessageList />
            </div>
            <PersonalTraining />
            <div v-if="showBanner" class="banner-help-container">
                <a :href="banner.link" target="_blank" rel="noopener noreferrer" @click="addLog()">
                    <img :src="banner.src" class="axxess-banner" />
                </a>
                <button class="banner-close" @click="closeBanner">X</button>
            </div>
        </section>
        <template>
            <router-view />
            <template v-if="showPatients || showEmployees">
                <Dialog
                    v-model:visible="showEmployees"
                    class="dashboard-dialog"
                    position="bottomright"
                    modal
                    :show-header="false"
                    :style="{ height: '100vh' }"
                >
                    <div class="h-100">
                        <EmployeeList v-model:showEmployees="showEmployees" />
                    </div>
                </Dialog>
                <Dialog
                    v-model:visible="showPatients"
                    class="dashboard-dialog"
                    position="bottomright"
                    modal
                    :show-header="false"
                    :style="{ height: '100vh' }"
                >
                    <div class="h-100">
                        <PatientList v-model:showPatients="showPatients" />
                    </div>
                </Dialog>
            </template>
        </template>
    </main>
</template>

<script lang="ts" src="./PersonalCenter.ts"></script>
<style src="./PersonalCenter.scss"></style>
